import EventBus from "@/utils/EventBus";

/** Recalculate fixed bottom UI (betslip bar, page padding). */
export function requestAppLayoutUpdate() {
  EventBus.emit("calculate-bottom-page");
}
